<template>
  <div
    class="position-relative bg-extra-light-gray rounded p-3 custom-shadow mb-3"
    :class="{ disableCard: disable }"
  >
    <h5 class="mb-0">{{ cardInfo.title }}</h5>
    <div
      v-for="(extraDataRow, extraDataRowIndex) in extraDataComputed"
      :key="extraDataRowIndex"
      class="d-flex flex-wrap"
    >
      <div
        class="mr-1"
        v-for="(extraDataRowItem, extraDataRowItemIndex) in extraDataRow"
        :key="extraDataRowItemIndex"
      >
        <small>{{ extraDataRowItem }}</small>
      </div>
    </div>
    <div
      v-if="!hideActions"
      class="actions-container d-flex justify-content-end mt-1"
    >
      <img
        class="b-action-item mr-2"
        :class="{ 'cursor-pointer': !disable }"
        @click="editItem"
        :src="imageEdit"
      />
      <img
        class="b-action-item mr-1"
        :class="{ 'cursor-pointer': !disable }"
        @click="deleteItem"
        :src="imageDelete"
      />
    </div>
    <div class="d-flex flex-row mt-2">
      <image-picker
        v-if="cardInfo.data.insuranceCardFrontBase64"
        :readOnly="true"
        :serverImageUrl="cardInfo.data.insuranceCardFrontUrl"
        class="mr-2"
        v-model="cardInfo.data.insuranceCardFrontBase64"
        labelText="Card Front"
      />
      <image-picker
        v-if="cardInfo.data.insuranceCardBackBase64"
        :readOnly="true"
        :serverImageUrl="cardInfo.data.insuranceCardBackUrl"
        v-model="cardInfo.data.insuranceCardBackBase64"
        labelText="Card Back"
      />
    </div>
  </div>
</template>

<script>
import ImagePicker from "./ImagePicker";
export default {
  name: "DataCard",
  props: ["cardInfo", "hideActions", "disable"],
  components: { ImagePicker },
  methods: {
    editItem() {
      if (!this.disable) {
        this.$emit("edit-item", {});
      }
    },
    deleteItem() {
      if (!this.disable) {
        this.$emit("delete-item", {});
      }
    }
  },
  computed: {
    extraDataComputed() {
      return this.cardInfo.extraData.map(extraDataRow => {
        const newExtraDataRow = [];
        for (let index = 0; index < extraDataRow.length; index++) {
          const item = extraDataRow[index];
          newExtraDataRow.push(item);
          if (index < extraDataRow.length - 1) newExtraDataRow.push("|");
        }
        return newExtraDataRow;
      });
    },
    imageEdit() {
      return this.isStandalone()
        ? "/icons/edit.svg"
        : "/desktop/icons/edit.svg";
    },
    imageDelete() {
      return this.isStandalone()
        ? "/icons/delete.svg"
        : "/desktop/icons/delete.svg";
    }
  }
};
</script>

<style scoped>
.custom-shadow {
  box-shadow: 5px 5px 5px -5px rgba(0, 0, 0, 0.5);
}
.actions-container {
  position: absolute;
  top: 5px;
  right: 5px;
}
.disableCard {
  opacity: 0.4;
}
</style>
